// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3E1gG","row":"ProcedureTreatmentSummary_row__gj3FQ"};